import * as Types from '../../../generated/graphql';

import { gql } from 'graphql.macro';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SessionFragment = (
  { __typename: 'CircleSessionNode' }
  & Pick<Types.CircleSessionNode, 'id' | 'uuid' | 'startTime' | 'rsvpLink' | 'bookingStatus'>
  & { facilitators: Array<Types.Maybe<(
    { __typename: 'CircleFacilitatorNode' }
    & CircleFacilitatorFragment
  )>>, topic: (
    { __typename: 'CircleTopicNode' }
    & Pick<Types.CircleTopicNode, 'id' | 'format' | 'name' | 'slug' | 'duration' | 'languageCode'>
    & { series: (
      { __typename: 'CircleSeriesNode' }
      & Pick<Types.CircleSeriesNode, 'id' | 'name' | 'slug' | 'accessType'>
    ) }
  ) }
);

export type CircleFacilitatorFragment = (
  { __typename: 'CircleFacilitatorNode' }
  & Pick<Types.CircleFacilitatorNode, 'id' | 'photo' | 'name' | 'credential' | 'country' | 'countryCode'>
);

export type FetchSessionsQueryVariables = Types.Exact<{
  topicId: Types.Scalars['ID'];
  afterDateTime: Types.Scalars['DateTime'];
  cursor?: Types.Maybe<Types.Scalars['String']>;
  limit?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type FetchSessionsQuery = (
  { __typename: 'Query' }
  & { circleTopic?: Types.Maybe<(
    { __typename: 'CircleTopicNode' }
    & Pick<Types.CircleTopicNode, 'name' | 'description' | 'duration' | 'format' | 'languageCode'>
  )>, circleSessionConnection: (
    { __typename: 'CircleSessionConnection' }
    & Pick<Types.CircleSessionConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<Types.PageInfo, 'endCursor' | 'hasNextPage'>
    ), edges: Array<Types.Maybe<(
      { __typename: 'CircleSessionEdge' }
      & Pick<Types.CircleSessionEdge, 'cursor'>
      & { node: (
        { __typename: 'CircleSessionNode' }
        & Pick<Types.CircleSessionNode, 'id'>
        & SessionFragment
      ) }
    )>> }
  ) }
);

export type FetchSessionQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['ID'];
}>;


export type FetchSessionQuery = (
  { __typename: 'Query' }
  & { circleSession?: Types.Maybe<(
    { __typename: 'CircleSessionNode' }
    & Pick<Types.CircleSessionNode, 'id'>
    & { topic: (
      { __typename: 'CircleTopicNode' }
      & Pick<Types.CircleTopicNode, 'name' | 'format' | 'duration' | 'languageCode'>
    ) }
    & SessionFragment
  )> }
);

export type FetchSessionsByDateTimeQueryVariables = Types.Exact<{
  startDateTime: Types.Scalars['DateTime'];
  endDateTime: Types.Scalars['DateTime'];
  after?: Types.Maybe<Types.Scalars['String']>;
  before?: Types.Maybe<Types.Scalars['String']>;
  first?: Types.Maybe<Types.Scalars['Int']>;
  last?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type FetchSessionsByDateTimeQuery = (
  { __typename: 'Query' }
  & { circleSessionsByDateTime: (
    { __typename: 'CircleSessionConnection' }
    & Pick<Types.CircleSessionConnection, 'totalCount'>
    & { edges: Array<Types.Maybe<(
      { __typename: 'CircleSessionEdge' }
      & Pick<Types.CircleSessionEdge, 'cursor'>
      & { node: (
        { __typename: 'CircleSessionNode' }
        & Pick<Types.CircleSessionNode, 'id'>
        & SessionFragment
      ) }
    )>> }
  ) }
);

export const CircleFacilitatorFragmentDoc = gql`
    fragment CircleFacilitator on CircleFacilitatorNode {
  id
  photo
  name
  credential
  country
  countryCode
}
    `;
export const SessionFragmentDoc = gql`
    fragment Session on CircleSessionNode {
  id
  uuid
  startTime
  rsvpLink
  bookingStatus
  facilitators {
    ...CircleFacilitator
  }
  topic {
    id
    format
    name
    slug
    duration
    languageCode
    series {
      id
      name
      slug
      accessType
    }
  }
}
    ${CircleFacilitatorFragmentDoc}`;
export const FetchSessionsDocument = gql`
    query fetchSessions($topicId: ID!, $afterDateTime: DateTime!, $cursor: String, $limit: Int = 10) {
  circleTopic(id: $topicId) {
    name
    description
    duration
    format
    languageCode
  }
  circleSessionConnection(
    topicId: $topicId
    first: $limit
    afterDateTime: $afterDateTime
    after: $cursor
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        ...Session
      }
    }
  }
}
    ${SessionFragmentDoc}`;

/**
 * __useFetchSessionsQuery__
 *
 * To run a query within a React component, call `useFetchSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSessionsQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      afterDateTime: // value for 'afterDateTime'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFetchSessionsQuery(baseOptions: Apollo.QueryHookOptions<FetchSessionsQuery, FetchSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSessionsQuery, FetchSessionsQueryVariables>(FetchSessionsDocument, options);
      }
export function useFetchSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSessionsQuery, FetchSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSessionsQuery, FetchSessionsQueryVariables>(FetchSessionsDocument, options);
        }
export type FetchSessionsQueryHookResult = ReturnType<typeof useFetchSessionsQuery>;
export type FetchSessionsLazyQueryHookResult = ReturnType<typeof useFetchSessionsLazyQuery>;
export type FetchSessionsQueryResult = Apollo.QueryResult<FetchSessionsQuery, FetchSessionsQueryVariables>;
export const FetchSessionDocument = gql`
    query fetchSession($sessionId: ID!) {
  circleSession(id: $sessionId) {
    id
    ...Session
    topic {
      name
      format
      duration
      languageCode
    }
  }
}
    ${SessionFragmentDoc}`;

/**
 * __useFetchSessionQuery__
 *
 * To run a query within a React component, call `useFetchSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useFetchSessionQuery(baseOptions: Apollo.QueryHookOptions<FetchSessionQuery, FetchSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSessionQuery, FetchSessionQueryVariables>(FetchSessionDocument, options);
      }
export function useFetchSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSessionQuery, FetchSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSessionQuery, FetchSessionQueryVariables>(FetchSessionDocument, options);
        }
export type FetchSessionQueryHookResult = ReturnType<typeof useFetchSessionQuery>;
export type FetchSessionLazyQueryHookResult = ReturnType<typeof useFetchSessionLazyQuery>;
export type FetchSessionQueryResult = Apollo.QueryResult<FetchSessionQuery, FetchSessionQueryVariables>;
export const FetchSessionsByDateTimeDocument = gql`
    query fetchSessionsByDateTime($startDateTime: DateTime!, $endDateTime: DateTime!, $after: String, $before: String, $first: Int, $last: Int) {
  circleSessionsByDateTime(
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    __typename
    ... on CircleSessionConnection {
      totalCount
      edges {
        cursor
        node {
          id
          ...Session
        }
      }
    }
  }
}
    ${SessionFragmentDoc}`;

/**
 * __useFetchSessionsByDateTimeQuery__
 *
 * To run a query within a React component, call `useFetchSessionsByDateTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSessionsByDateTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSessionsByDateTimeQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useFetchSessionsByDateTimeQuery(baseOptions: Apollo.QueryHookOptions<FetchSessionsByDateTimeQuery, FetchSessionsByDateTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSessionsByDateTimeQuery, FetchSessionsByDateTimeQueryVariables>(FetchSessionsByDateTimeDocument, options);
      }
export function useFetchSessionsByDateTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSessionsByDateTimeQuery, FetchSessionsByDateTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSessionsByDateTimeQuery, FetchSessionsByDateTimeQueryVariables>(FetchSessionsByDateTimeDocument, options);
        }
export type FetchSessionsByDateTimeQueryHookResult = ReturnType<typeof useFetchSessionsByDateTimeQuery>;
export type FetchSessionsByDateTimeLazyQueryHookResult = ReturnType<typeof useFetchSessionsByDateTimeLazyQuery>;
export type FetchSessionsByDateTimeQueryResult = Apollo.QueryResult<FetchSessionsByDateTimeQuery, FetchSessionsByDateTimeQueryVariables>;